import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { Input } from '../../../ui/input';
import { Label } from '../../../ui/label';
import CurrencyInput from './CurrencyInput';

interface LoanProposalSectionProps {
  projection: any;
  calculated: any;
  onChange: (field: string, value: string | number) => void;
}

export default function LoanProposalSection({
  projection,
  calculated,
  onChange,
}: LoanProposalSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg text-blue-600">Usulan Pinjaman & Angsuran</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-6">
          {/* Row 1 */}
          <div className="grid md:grid-cols-3 gap-4">
            <div className="space-y-2">
              <Label className="text-sm">Repayment Capacity Dari Net Cash Flow</Label>
              <div className="flex gap-2">
                <Input
                  type="number"
                  value={projection.repayment_capacity_pct ?? ''}
                  onChange={e =>
                    onChange('repayment_capacity_pct', e.target.value === '' ? '' : e.target.value)
                  }
                  className="text-right font-semibold focus:border-blue-500"
                />
                <span className="flex items-center">%</span>
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-sm">
                Nominal Minimal untuk Saldo Kas & Bank Setelah Pencairan
              </Label>
              <CurrencyInput
                value={calculated.nominalMinimalAfter}
                readOnly
                className="font-semibold"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-sm">
                Nominal Saldo Awal Kas & Bank Calon Debitur Sebelum Pencairan
              </Label>
              <CurrencyInput
                value={calculated.saldoAwalBefore}
                readOnly
                className="font-semibold"
              />
            </div>
          </div>

          {/* Row 2 */}
          <div className="grid md:grid-cols-4 gap-4">
            <div className="space-y-2">
              <Label className="text-sm">Usulan Plafon</Label>
              <CurrencyInput
                value={projection.kredit_usulan}
                onChange={value => onChange('kredit_usulan', value)}
                className="font-semibold"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-sm">Suku Bunga Flat</Label>
              <div className="flex gap-2">
                <Input
                  type="number"
                  step="0.01"
                  value={projection.suku_bunga_flat ?? ''}
                  onChange={e =>
                    onChange('suku_bunga_flat', e.target.value === '' ? '' : e.target.value)
                  }
                  className="text-right font-semibold focus:border-blue-500"
                />
                <span className="flex items-center">%</span>
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-sm">Tenor / Jangka Waktu</Label>
              <div className="flex gap-2">
                <Input
                  type="number"
                  value={projection.tenor_bulan}
                  onChange={e => onChange('tenor_bulan', e.target.value)}
                  className="text-right font-semibold focus:border-blue-500"
                />
                <span className="flex items-center text-sm">bulan</span>
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-sm">LTV of Collateral</Label>
              <Input
                type="text"
                placeholder="Auto calculated"
                readOnly
                className="text-right bg-gray-100"
              />
            </div>
          </div>

          {/* Row 3 */}
          <div className="grid md:grid-cols-4 gap-4">
            <div className="space-y-2">
              <Label className="text-sm">Jumlah Angsuran per Bulan</Label>
              <CurrencyInput
                value={calculated.angsuranPerBulan}
                readOnly
                className="font-bold text-blue-700"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-sm">Angsuran Bunga</Label>
              <CurrencyInput value={calculated.angsuranBunga} readOnly />
            </div>
            <div className="space-y-2">
              <Label className="text-sm">Angsuran Pokok</Label>
              <CurrencyInput value={calculated.angsuranPokok} readOnly />
            </div>
            <div className="space-y-2">
              <Label className="text-sm">LTV of Financing</Label>
              <Input type="text" placeholder="100%" readOnly className="text-right bg-gray-100" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
